export class PDFExportOptions {
	orientation: 'portrait' | 'landscape' = 'portrait';
	printerFriendly = false;
	showComments = true;
}